import { useMemo } from 'react';
import { UseQueryOptions } from 'react-query';
import ISchemas from '@/services/apis/user/schemas';
import { cacheableQueryOptions, useAPI } from '@/services/utils';
import { useAuthCSRSession } from '@/modules/auth/hooks/AuthSession';

export type TUserData = ISchemas['getMe']['output'];

export const useGetUser = ({
  enabled = true,
  ...reactQueryOptions
}: UseQueryOptions<any> = {}) => {
  const { getSession } = useAuthCSRSession();
  return useAPI(['user', 'getMe'], {
    reactQueryOptions: {
      ...cacheableQueryOptions,
      enabled: enabled && !!getSession(),
      ...reactQueryOptions,
    },
  });
};

// TODO: convert it to positive name
export const useHasNotEContractV2 = (): boolean => {
  const { data } = useGetUser();
  return useMemo<boolean>(() => !!data && !data?.hasEContractV2, [data]);
};
